// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import { useParams, useNavigate } from "react-router-dom";
// import supabase from "../../../supabaseClient";
// import "./BlogForm.css"; // Ensure this file exists and is properly linked

// function BlogForm() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [title, setTitle] = useState("");
//   const [thumbnail, setThumbnail] = useState("");
//   const [content, setContent] = useState("");
//   const [author, setAuthor] = useState("");
//   const [tags, setTags] = useState("");
//   const [date, setDate] = useState(""); // Add a state for date

//   useEffect(() => {
//     if (id) fetchBlog();
//   }, [id]);

//   const fetchBlog = async () => {
//     let { data: blog, error } = await supabase
//       .from("blogs")
//       .select("*")
//       .eq("id", id)
//       .single();
//     if (error) console.log("Error fetching blog:", error);
//     else {
//       setTitle(blog.title);
//       setThumbnail(blog.thumbnail);
//       setContent(blog.content);
//       setAuthor(blog.author);
//       setTags(blog.tags);
//       setDate(blog.date || ""); // Set the date if it exists
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const blogData = { title, thumbnail, content, author, tags, date }; // Include date in the data
//     if (id) {
//       let { error } = await supabase
//         .from("blogs")
//         .update(blogData)
//         .eq("id", id);
//       if (error) console.log("Error updating blog:", error);
//     } else {
//       let { error } = await supabase.from("blogs").insert([blogData]);
//       if (error) console.log("Error adding blog:", error);
//     }
//     navigate("/blog/admin");
//   };

//   return (
//     <Container className="blog-form" data-aos="fade-up">
//       <Row>
//         <Col md={8} className="mx-auto">
//           <h2>{id ? "Edit Blog" : "Add New Blog"}</h2>
//           <Form onSubmit={handleSubmit}>
//             <Form.Group controlId="formTitle" className="mb-3">
//               <Form.Label>Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter title"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 required
//               />
//             </Form.Group>
//             <Form.Group controlId="formThumbnail" className="mb-3">
//               <Form.Label>Thumbnail URL</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter thumbnail URL"
//                 value={thumbnail}
//                 onChange={(e) => setThumbnail(e.target.value)}
//                 required
//               />
//             </Form.Group>
//             <Form.Group controlId="formContent" className="mb-3">
//               <Form.Label>Content</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={6}
//                 placeholder="Enter content"
//                 value={content}
//                 onChange={(e) => setContent(e.target.value)}
//                 required
//               />
//             </Form.Group>
//             <Form.Group controlId="formAuthor" className="mb-3">
//               <Form.Label>Author</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter author name"
//                 value={author}
//                 onChange={(e) => setAuthor(e.target.value)}
//                 required
//               />
//             </Form.Group>
//             <Form.Group controlId="formTags" className="mb-3">
//               <Form.Label>Tags (comma-separated)</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter tags"
//                 value={tags}
//                 onChange={(e) => setTags(e.target.value)}
//                 required
//               />
//             </Form.Group>
//             <Form.Group controlId="formDate" className="mb-3">
//               <Form.Label>Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={date}
//                 onChange={(e) => setDate(e.target.value)}
//                 required
//               />
//             </Form.Group>
//             <Button variant="primary" type="submit">
//               {id ? "Update Blog" : "Add Blog"}
//             </Button>
//           </Form>
//         </Col>
//       </Row>
//     </Container>
//   );
// }

// export default BlogForm;

import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import supabase from "../../../supabaseClient";
import "./BlogForm.css";

function BlogForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [content, setContent] = useState("");
  const [author, setAuthor] = useState("");
  const [tags, setTags] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    if (id) fetchBlog(); // Fetch the blog based on the ID
  }, [id]);

  // Fetch the blog details including the thumbnail from Supabase
  const fetchBlog = async () => {
    const { data: blog, error } = await supabase
      .from("blogs")
      .select("*")
      .eq("id", id)
      .single(); // Get a single blog post by its ID

    if (error) {
      console.log("Error fetching blog:", error);
    } else {
      setTitle(blog.title);
      setThumbnail(blog.thumbnail); // Set the thumbnail URL from the blog data
      setContent(blog.content);
      setAuthor(blog.author);
      setTags(blog.tags);
      setDate(blog.date || "");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const blogData = {
      title,
      thumbnail,
      content,
      author,
      tags,
      date,
    };

    if (id) {
      // Update the existing blog
      const { error } = await supabase
        .from("blogs")
        .update(blogData)
        .eq("id", id);
      if (error) console.log("Error updating blog:", error);
    } else {
      // Insert a new blog
      const { error } = await supabase.from("blogs").insert([blogData]);
      if (error) console.log("Error adding blog:", error);
    }

    navigate("/blog/admin");
  };

  return (
    <Container className="blog-form" data-aos="fade-up">
      <Row>
        <Col md={8} className="mx-auto">
          <h2>{id ? "Edit Blog" : "Add New Blog"}</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formTitle" className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>

            {/* Thumbnail Preview - fetch based on blog ID */}
            {thumbnail && (
              <Form.Group controlId="formThumbnail" className="mb-3">
                <Form.Label>Thumbnail Preview</Form.Label>
                <div className="thumbnail-preview mt-2">
                  <img
                    src={thumbnail}
                    alt="Thumbnail Preview"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </Form.Group>
            )}

            <Form.Group controlId="formContent" className="mb-3">
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                placeholder="Enter content"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formAuthor" className="mb-3">
              <Form.Label>Author</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter author name"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formTags" className="mb-3">
              <Form.Label>Tags (comma-separated)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tags"
                value={tags}
                onChange={(e) => setTags(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formDate" className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              {id ? "Update Blog" : "Add Blog"}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default BlogForm;

